export const socialBox = (theme) => ({
    root: {
        width: "100%",
        padding: theme.spacing(8, 16),
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(5, 2),
        },
        backgroundColor: "#F9F9F9",
    },
    box: {
        backgroundColor: "#fff",
        boxShadow: "none",
    },
    icon: {
        height: 60,
        width: "auto",
        [theme.breakpoints.down("xs")]: {
            height: 30,
        },
    },
    hashtag: {
        borderRight: "1px solid #F1F1F1",
    },
});
